import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';


  const firebaseConfig = {
    apiKey: "AIzaSyCHGpQEgoYymo2z3YQzcZ_ts-_4gNyuXSU",
    authDomain: "imaginarywebsite-3bb40.firebaseapp.com",
    projectId: "imaginarywebsite-3bb40",
    storageBucket: "imaginarywebsite-3bb40.appspot.com",
    messagingSenderId: "601124126178",
    appId: "1:601124126178:web:6431052ef0af801a0e4dbb",
    measurementId: "G-9GJCC9VF63"
  };

  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);

  const projectFirestore = firebase.firestore();

  export { projectFirestore};

  
